import { IDicom } from 'models/icardio';

export const getDicomMediaType = (
  mediaType?: IDicom['mediaType'],
  numberOfFrames?: number | null
) => {
  if (mediaType) return mediaType;
  if (numberOfFrames === 1) return 'Single Frame';
  if (numberOfFrames && numberOfFrames > 1) return 'Video';
  return undefined;
};
